import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { modalEmailMessagesState } from 'Hooks/useModalEmailMessages/useModalEmailMessages'

import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text
} from 'mailup-web-components'
import styled from '@emotion/styled'

import { modalUsedMessageState } from 'Pages/AbTestWizard/recoil/state/modals'
import { abTestState } from 'Pages/AbTestWizard/recoil/state/abtest'

const NameText = styled.span`
  display: inline;
  word-break: break-all;
`

const ModalMessageInUse = () => {
  const intl = useIntl()

  const [modalEmailState, setModalEmailState] = useRecoilState(
    modalEmailMessagesState
  )
  const [modalUsedMessage, setModalUsedMessage] = useRecoilState(
    modalUsedMessageState
  )
  const setAbTestState = useSetRecoilState(abTestState)

  const setSelectedMessageObj = value => {
    return {
      IdMessaggio: value.Id,
      IdInvio: 0,
      TipoInvio: 1,
      IdSchedule: 0,
      Queued: 0,
      ToBeQueued: 0,
      Subject: value.Subject,
      Note: value.Note,
      HasThumbnail: value.HasThumbnail,
      LastUpdated: value.LastUpdated
    }
  }

  const onClickConfirmModalUsedMessage = () => {
    setModalUsedMessage(prev => ({
      ...prev,
      show: false
    }))

    setModalEmailState(prev => ({
      ...prev,
      show: true,
      fetchAfterCopy: true,
      selectedItem: undefined
    }))
  }

  const onClickCancelModalUsedMessage = value => {
    setModalUsedMessage(prev => ({
      ...prev,
      show: false
    }))

    if (value === 'keep') {
      if (modalEmailState.selectedItem) {
        setAbTestState(prev => ({
          ...prev,
          step1: {
            ...prev.step1,
            abTestMessages: [
              ...prev.step1.abTestMessages,
              setSelectedMessageObj(modalEmailState.selectedItem)
            ]
          }
        }))
      }
    }
  }

  return (
    <>
      <Modal
        show={modalUsedMessage.show}
        onClose={() => onClickCancelModalUsedMessage('discard')}
        data-mu-test='abTestWizard__modal-message-in-use'
      >
        <ModalHead
          title={intl.formatMessage({
            id: 'Load.ABTestWizard.WarningMessageSelectedTitle'
          })}
        />
        <ModalBody>
          <Text>
            {intl.formatMessage(
              { id: 'Load.ABTestWizard.WarningMessageSelectedParagraph' },
              {
                X: <NameText>{modalUsedMessage.entityName}</NameText>,
                strong: t => <strong>{t}</strong>
              }
            )}
          </Text>
        </ModalBody>

        <ModalFoot>
          <Button
            onClick={() => onClickCancelModalUsedMessage('keep')}
            kind='danger'
            data-mu-test='abTestWizard__modal-message-in-use__btn-ignore'
          >
            {intl.formatMessage({
              id: 'Load.ABTestWizard.WarningMessageSelectedSecondaryBtn'
            })}
          </Button>
          <Button
            onClick={onClickConfirmModalUsedMessage}
            kind='primary'
            data-mu-test='abTestWizard__modal-message-in-use__btn-confirm'
          >
            {intl.formatMessage({
              id: 'Load.ABTestWizard.WarningMessageSelectedMainBtn'
            })}
          </Button>
        </ModalFoot>
      </Modal>
    </>
  )
}

export default ModalMessageInUse
